import { createSlice } from "@reduxjs/toolkit";

const authForgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState: {
    email: "",
    otpCode: "",
    password: "",
    passwordconf: "",
  },
  reducers: {
    setEmail: (state, action) => {
      state.email = action.payload;
    },
    setOtpCode: (state, action) => {
      state.otpCode = action.payload;
    },
    setPassword: (state, action) => {
      state.password = action.payload;
    },
    setPasswordConf: (state, action) => {
      state.passwordconf = action.payload;
    },
  },
});

export const { setEmail, setOtpCode, setPassword, setPasswordConf } =
  authForgotPasswordSlice.actions;
export default authForgotPasswordSlice.reducer;
